export const testRefToDataTestReference = (props) => ({ 'data-test-reference': props.testRef });
export const passPropsThrough = (attrs) => (props) => ({
  ...attrs,
  ...props,
});
export const defineGridArea = (area) => `.${area} { grid-area: ${area}; }`;
